import styled from 'styled-components';

export const Select = styled.select`
  border-radius: 4px;
  border: 1px solid #000;
  width: 100%;
  max-width: 200px;
  height: 36px;
`;
